import { render, staticRenderFns } from "./AddZoneGroup.vue?vue&type=template&id=13af459a"
import script from "./AddZoneGroup.vue?vue&type=script&lang=js"
export * from "./AddZoneGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports